module.exports = __webpack_public_path__ + "img/237.b6eb87d8.png";